var exports = {
  "az": "Box__PalQtd",
  "wy": "Box_1__424Y1a",
  "pv": "Box_2__ya9av3",
  "w9": "Box_3__YmizrJ",
  "pQ": "Box_4__lMmroC",
  "$n": "Button__AyoG5z",
  "ws": "Box_5__ylF4xv",
  "Tr": "Button_1__fgoRfX",
  "D6": "Box_6__yyTyGl",
  "KI": "Box_7___EeUQ3",
  "pm": "Box_8__HUWALD",
  "Lw": "FileResultsList__pEF5yB",
  "w0": "Box_9__oco6tt",
  "Oh": "Box_10__Oxn5mw",
  "HF": "Box_11__e1F7PX",
};

module.exports = exports;
